import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsFront } from '../../organisms/settings/front/SettingsFront';

/**
 * presentations/components/pages/SettingsPage.tsx
 */
const SettingsPage: React.FC = () => (
  <>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <SettingsFront />
      </SettingsWrapper>
    </div>
  </>
);

export default SettingsPage;
